<template>
  <Card title="Test CiinaboxDeployments Graph Card">
    <div class="summary-content">
      <!-- Use v-show to persist the DOM element -->
      <DeploymentsGraph
  v-if="showGraph && graphReady && graphMetrics.length"
  :metrics="graphMetrics"
  :name="'Deployments'"
  :date="currentDate"
  :id="entityId"
  @updateMetric="handleMetricUpdate"
/>

<div v-else-if="graphReady" class="text-gray-500 text-sm italic mt-2">
  No deployments available to render graph.
</div>

      <div class="kpi-section mt-4">
        <h4 class="text-lg font-semibold mb-2">Current State</h4>
        <dl class="grid grid-cols-2 gap-2 text-sm">
          <dt>Deployments Displayed</dt>
          <dd>{{ filteredDeploymentCount !== null ? filteredDeploymentCount : 'N/A' }}</dd>

          <template v-if="activeType === 'group'">
            <dt>Contracts</dt>
            <dd>{{ contractCount !== null ? contractCount : 'N/A' }}</dd>
          </template>

          <template v-if="activeType === 'contract'">
            <dt>Stacks</dt>
            <dd>{{ stackCount !== null ? stackCount : 'N/A' }}</dd>
          </template>

          <template v-if="activeStack">
            <dt>Filtering by Stack</dt>
            <dd>{{ activeStack }}</dd>
          </template>

          <dt>Reporting Period Ending</dt>
          <dd>{{ formattedDate ? formattedDate : 'N/A' }}</dd>
        </dl>
      </div>
    </div>
  </Card>
</template>

<script>
import Card from '../Card.vue'
import DeploymentsGraph from '@/components/DeploymentsGraph'
import HTTP from '@/common/http'

export default {
  name: 'TestCiinaboxDeploymentsGraphCard',
  components: {
    Card,
    DeploymentsGraph
  },
  props: {
    entityId: {
      type: [String, Number],
      required: true
    },
    activeType: {
      type: String,
      required: true
    },
    showGraph: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      deployments: [],
      metrics: [],
      graphMetrics: [],
      contractCount: null,
      stackCount: null,
      filteredDeploymentCount: null,
      activeStack: null,
      currentDate: null,
      graphReady: false
    }
  },
  computed: {
    formattedDate () {
      if (!this.currentDate) return null
      try {
        const date = new Date(this.currentDate)
        return isNaN(date.getTime())
          ? this.currentDate
          : new Intl.DateTimeFormat('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
          }).format(date)
      } catch (e) {
        return this.currentDate
      }
    }
  },
  created () {
    this.fetchMetricsAndDeployments()
  },
  methods: {
    handleMetricUpdate (event) {
      this.$emit('updateMetric', event)
    },
    transformDeploymentsToMetrics (deployments) {
      const grouped = {}
      for (let i = 0; i < deployments.length; i++) {
        const dep = deployments[i]
        const date = (dep.EventTime && dep.EventTime.split('T')[0]) || 'Unknown'
        if (!grouped[date]) grouped[date] = 0
        grouped[date] += 1
      }
      const result = []
      for (const key in grouped) {
        result.push({ date: key, value: grouped[key] })
      }
      return result
    },
    fetchMetricsAndDeployments () {
      this.graphReady = false
      HTTP.get('/ciinabox/metrics/' + this.activeType + '/' + this.entityId + '/month')
        .then((metricsRes) => {
          this.metrics = metricsRes.data.metrics || []
          this.currentDate =
            (this.metrics.length >= 12 && this.metrics[11] && this.metrics[11].date) ||
            (this.metrics.length && this.metrics[this.metrics.length - 1].date) ||
            null

          return HTTP.get('/ciinabox/summary/' + this.activeType + '/' + this.entityId + '/' + this.currentDate)
        })
        .then((response) => {
          this.deployments = response.data.deployments || []
          this.filteredDeploymentCount = this.deployments.length
          this.contractCount = (response.data.contracts && response.data.contracts.length) || 0

          const stackNames = []
          for (let i = 0; i < this.deployments.length; i++) {
            const dep = this.deployments[i]
            const name =
              dep.StackName ||
              (dep.CloudTrailEvent &&
                dep.CloudTrailEvent.requestParameters &&
                dep.CloudTrailEvent.requestParameters.stackName)
            if (name && stackNames.indexOf(name) === -1) {
              stackNames.push(name)
            }
          }
          this.stackCount = stackNames.length
          this.graphMetrics = this.transformDeploymentsToMetrics(this.deployments)
        })
        .catch((err) => {
          console.error('Error fetching deployments or metrics:', err)
          this.deployments = []
          this.metrics = []
          this.graphMetrics = []
          this.filteredDeploymentCount = 0
        })
        .finally(() => {
          // Trigger graph rendering once everything is ready
          this.graphReady = true
        })
    }
  }
}
</script>

<style scoped>
.kpi-section dt {
  font-weight: 600;
}
.kpi-section dd {
  margin-bottom: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Cards/InfoCards/TestDeployments.vue